"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USS = void 0;
var axios_1 = require("axios");
var utils_1 = require("./utils");
var etag_1 = require("./etag");
var types_1 = require("./types");
var imageType2ContentType = new Map([
    ['jpg', types_1.ContentTypeHeader.image],
    ['jpeg', types_1.ContentTypeHeader.image],
    ['png', types_1.ContentTypeHeader.pngImage]
]);
var USS = /** @class */ (function () {
    function USS(options) {
        this.queueMap = new Map();
        this.bucket = options.bucket;
        this.domain = options.domain;
        this.concurrency = options.concurrency || 3;
        this.$ = axios_1.default.create({
            baseURL: options.uploadDomain + "/api/v2",
            headers: {
                Authorization: options.authorization
            }
        });
        this.$.interceptors.response.use(function (response) { return response; }, function (error) {
            var _a, _b, _c, _d, _e, _f, _g;
            if (axios_1.default.isCancel(error)) {
                return Promise.reject(new utils_1.Error({
                    code: types_1.ErrorCode.UserCancel,
                    message: 'User cancel.',
                    error: error
                }));
            }
            if ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) {
                return Promise.reject(new utils_1.Error({
                    code: (_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.code,
                    message: (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message,
                    error: error,
                    httpCode: (_g = error === null || error === void 0 ? void 0 : error.response) === null || _g === void 0 ? void 0 : _g.status
                }));
            }
            return Promise.reject(error);
        });
        this.sliceSize = options.sliceSize;
    }
    USS.prototype.putObject = function (_a) {
        var file = _a.file, contentType = _a.contentType, cancelToken = _a.cancelToken, onUploadProgress = _a.onUploadProgress, autoPicType = _a.autoPicType;
        return __awaiter(this, void 0, void 0, function () {
            var autoExt, etag, storage, toBeUploadedSlices, uploadedSlices, shouldSlice, _loop_1, this_1, index, data, tasks, queue, tokenQueues;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        autoExt = autoPicType && file.name.split('.').pop();
                        return [4 /*yield*/, etag_1.getEtag(file)];
                    case 1:
                        etag = _b.sent();
                        storage = utils_1.createStorage(etag);
                        toBeUploadedSlices = [];
                        uploadedSlices = (storage.get() || []).reduce(function (acc, cur) {
                            return acc.concat(acc.find(function (item) { return item.index === cur.index; }) ? [] : [cur]);
                        }, []);
                        shouldSlice = file.size > this.sliceSize;
                        if (shouldSlice) {
                            _loop_1 = function (index) {
                                var start = this_1.sliceSize * index;
                                var end = start + this_1.sliceSize;
                                var size = (end <= file.size ? end : file.size) - start;
                                var slice = file.slice(start, start + size);
                                var isSliceUploaded = !!uploadedSlices.find(function (item) { return item.index === index; });
                                if (!isSliceUploaded) {
                                    toBeUploadedSlices.push({
                                        index: index,
                                        slice: slice,
                                        size: size
                                    });
                                }
                            };
                            this_1 = this;
                            for (index = 0; index < file.size / this.sliceSize; index++) {
                                _loop_1(index);
                            }
                        }
                        else {
                            toBeUploadedSlices.push({
                                index: 0,
                                slice: file,
                                size: file.size
                            });
                        }
                        if (!(toBeUploadedSlices.length === 0)) return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, , 4, 5]);
                        return [4 /*yield*/, this.mergeObject(etag, uploadedSlices, contentType, cancelToken, autoExt)];
                    case 3:
                        data = _b.sent();
                        return [2 /*return*/, __assign(__assign({}, data), { url: this.getFileUrl(data.fid, contentType, autoExt) })];
                    case 4:
                        storage.remove();
                        return [7 /*endfinally*/];
                    case 5:
                        tasks = toBeUploadedSlices.map(function (_a) {
                            var slice = _a.slice, size = _a.size, index = _a.index;
                            return function () { return __awaiter(_this, void 0, void 0, function () {
                                var sliceEtag;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, etag_1.getEtag(slice)];
                                        case 1:
                                            sliceEtag = _a.sent();
                                            return [2 /*return*/, this.$.post("/upload/" + this.bucket, slice, {
                                                    cancelToken: cancelToken.token,
                                                    headers: {
                                                        ETag: sliceEtag,
                                                        'Content-Type': shouldSlice
                                                            ? types_1.ContentTypeHeader.slice
                                                            : this.getContentTypeHeader(contentType, autoExt)
                                                    }
                                                }).then(function (res) {
                                                    var data = res.data.data;
                                                    return {
                                                        data: __assign(__assign({}, data), { url: _this.getFileUrl(data.fid, contentType, autoExt) }),
                                                        size: size,
                                                        index: index
                                                    };
                                                })];
                                    }
                                });
                            }); };
                        });
                        queue = new utils_1.Queue(tasks, { concurrency: this.concurrency });
                        tokenQueues = this.queueMap.get(cancelToken) || new Set();
                        this.queueMap.set(cancelToken, tokenQueues.add(queue));
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var fulfilled = 0;
                                queue.setTaskFullfilledHandler(function (_a) {
                                    var data = _a.data, size = _a.size, index = _a.index;
                                    return __awaiter(_this, void 0, void 0, function () {
                                        var loaded, data_1, error_1;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    if (!uploadedSlices.find(function (item) { return item.index === index; })) {
                                                        uploadedSlices.push({ index: index, size: size, fid: data.fid });
                                                    }
                                                    loaded = uploadedSlices.reduce(function (acc, cur) { return acc + cur.size; }, 0);
                                                    onUploadProgress === null || onUploadProgress === void 0 ? void 0 : onUploadProgress({
                                                        total: file.size,
                                                        loaded: loaded,
                                                        percent: parseFloat((loaded / file.size).toFixed(2))
                                                    });
                                                    if (tasks.length === 1 && !shouldSlice) {
                                                        storage.remove();
                                                        resolve(__assign(__assign({}, data), { url: this.getFileUrl(data.fid, contentType, autoExt) }));
                                                        return [2 /*return*/];
                                                    }
                                                    storage.set(uploadedSlices);
                                                    if (!(++fulfilled === tasks.length)) return [3 /*break*/, 5];
                                                    _b.label = 1;
                                                case 1:
                                                    _b.trys.push([1, 3, 4, 5]);
                                                    return [4 /*yield*/, this.mergeObject(etag, uploadedSlices, contentType, cancelToken, autoExt)];
                                                case 2:
                                                    data_1 = _b.sent();
                                                    resolve(__assign(__assign({}, data_1), { url: this.getFileUrl(data_1.fid, contentType, autoExt) }));
                                                    return [3 /*break*/, 5];
                                                case 3:
                                                    error_1 = _b.sent();
                                                    reject(error_1);
                                                    return [3 /*break*/, 5];
                                                case 4:
                                                    storage.remove();
                                                    return [7 /*endfinally*/];
                                                case 5: return [2 /*return*/];
                                            }
                                        });
                                    });
                                });
                                queue.setAllTaskFullfilledHandler(function () {
                                    var tokenQueues = _this.queueMap.get(cancelToken) || new Set();
                                    tokenQueues.delete(queue);
                                    _this.queueMap.set(cancelToken, tokenQueues);
                                });
                                queue.setTaskRejectedHandler(function (error) {
                                    storage.remove();
                                    _this.cancel(cancelToken);
                                    reject(error);
                                });
                                queue.start();
                            })];
                }
            });
        });
    };
    USS.prototype.cancel = function (token) {
        var queues = this.queueMap.get(token);
        queues === null || queues === void 0 ? void 0 : queues.forEach(function (queue) { return queue.cancel(); });
        token.cancel();
    };
    USS.prototype.resume = function (token) {
        var queues = this.queueMap.get(token);
        queues === null || queues === void 0 ? void 0 : queues.forEach(function (queue) { return queue.resume(); });
    };
    USS.prototype.getFileUrl = function (fid, contentType, autoExt) {
        var ext;
        switch (contentType) {
            case types_1.ContentType.video:
                ext = types_1.FileExt.video;
                break;
            case types_1.ContentType.audio:
                ext = types_1.FileExt.audio;
                break;
            default:
                ext = imageType2ContentType.has(autoExt) ? autoExt : types_1.FileExt.image;
                break;
        }
        return this.domain + '/' + this.bucket + '/' + fid + '.' + ext;
    };
    USS.prototype.getContentTypeHeader = function (contentType, autoExt) {
        if (autoExt && imageType2ContentType.has(autoExt)) {
            return imageType2ContentType.get(autoExt);
        }
        return types_1.ContentTypeHeader[contentType];
    };
    USS.prototype.mergeObject = function (etag, slices, contentType, cancelToken, autoExt) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$.post("/mergeFiles/" + this.bucket, {
                            fids: slices.map(function (item) { return ({ index: item.index, fid: item.fid }); })
                        }, {
                            headers: {
                                ETag: etag,
                                'Content-Type': this.getContentTypeHeader(contentType, autoExt)
                            },
                            cancelToken: cancelToken.token
                        })];
                    case 1:
                        res = _a.sent();
                        data = res.data.data;
                        return [2 /*return*/, {
                                url: this.getFileUrl(data.fid, contentType, autoExt),
                                etag: data.etag,
                                fid: data.fid
                            }];
                }
            });
        });
    };
    return USS;
}());
exports.USS = USS;
